import { NumberField } from '@doordash/component-fields'
import {
  Text,
  StackChildren,
} from '@doordash/design-language'
import * as React from 'react'
import { PaddedLabel } from './styles'
import InternationalNumberField from '../international-numberfield'

import t from './strings'

type Props = {
  currentDay: number
  minDay?: number
  handleChange: (field, value) => void
  error?: string
  dayAnchorId?: string
  locale?: string
}


export const DaySplit: React.FC<Props> = (props) => (
  <StackChildren size={StackChildren.Sizes.XxxSmall}>
    <PaddedLabel
      size={Text.Sizes.Small}
      color={Text.Colors.Tertiary}
      htmlFor="day"
    >
      {t.day()}
    </PaddedLabel>
    { props.locale ?
      <InternationalNumberField
        id="day"
        accessibilityDescribedBy={'birthdateDay'}
        max={31}
        value={props.currentDay}
        placeholder={props.minDay}
        onChange={val => props.handleChange('currentDay', val)}
        error={props.error && true}
        label={t.day()}
        anchorId={props.dayAnchorId}
        locale={props.locale}
      /> :
      <NumberField
        id="day"
        accessibilityDescribedBy={'birthdateDay'}
        max={31}
        value={props.currentDay}
        placeholder={props.minDay}
        onChange={val => props.handleChange('currentDay', val)}
        error={props.error && true}
        autoComplete="off"
        label={t.day()}
        data-anchor-id={props.dayAnchorId}
        isLabelHidden
      />
    }
  </StackChildren>
)

export default DaySplit
